
define('modules/application/widgets/consumptionIndicator',[
  "app",

  // Libs
  "backbone",

  //Classes
  "../header"

],

function(app, Backbone, Header) {

  var consumptionIndicatorView = Backbone.View.extend({
    tagName    : "section",
    className  : "consumptionIndicator",
    template   : "application/widgets/consumptionIndicator",
    serialize  : function() {return {model : this.model, app : BticinoS4B.Instances.Models.ApplicationModel};},
    initialize : function() {
      /*Binding events*/
      this.model.unbind("change:percentageOfTotalCurrentConsumption", this.updateBar);
      this.model.bind("change:percentageOfTotalCurrentConsumption",   this.updateBar, this);

      this.model.unbind("change:percentageOfTotalCurrentConsumption", this.updateTitle);
      this.model.bind("change:percentageOfTotalCurrentConsumption",   this.updateTitle, this);

      this.fullWidth = 125;
    },

    updateBar  : function()
    {
      var that            = this;
      var newPercentage   = this.fullWidth-this.model.get("percentageOfTotalCurrentConsumption");
      var animationTimer  = this.model.get("animationTimer");
      var startAnimation  = this.startAnimation;
      var callbackFunction= function() {
        clearInterval(that.model.get("animationTimer"));
      };

      if(animationTimer)
        clearInterval(animationTimer);

      animationTimer = setInterval(function() {startAnimation(that, newPercentage, callbackFunction);}, 100);
      this.model.set("animationTimer", animationTimer);
    },

    startAnimation  : function(that, newPercentage, callback)
    {
      if (newPercentage < 0)
        newPercentage = 0;

      that.$el.find(".greyBar").stop(true, true).animate({
        width : (newPercentage*0.8)+"%"
      },
      {
        duration: 100,
        specialEasing: {
          width: 'swing'
        },
        complete : callback
      });
    },

    updateTitle     : function() {
      var newPercentage   = this.fullWidth-this.model.get("percentageOfTotalCurrentConsumption");

      if (newPercentage<=1)
        this.$el.addClass("overConsumption");
      else
        this.$el.removeClass("overConsumption");
      
      this.render();
    }
  });

  var consumptionIndicatorModel= Backbone.Model.extend({
    defaults : {
      totalSupplyCurrent      : 0,
      totalCurrentConsumption : 0,
      percentageOfTotalCurrentConsumption : 0
    },

    initialize : function() {
      var that = this;
      BticinoS4B.Instances.Models.ApplicationModel.set("maxExtraConsumption", []);

      /*Binding events*/
      this.unbind("change:totalSupplyCurrent",           this.recalculatePercentages);
      this.bind("change:totalSupplyCurrent",             this.recalculatePercentages, this);

      this.unbind("change:totalCurrentConsumption",      this.recalculatePercentages);
      this.bind("change:totalCurrentConsumption",        this.recalculatePercentages, this);

      window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested", this.resetCurrents);
      window.BticinoS4B.eventAggregator.bind("currentDeliver:requested",   this.resetCurrents, this);

      /*Animation Test*/
      //self.setInterval(function(){that.set("totalCurrentConsumption", Math.floor((Math.random()*125)+1));},1000);
    },

    addSupplyCurrent                           : function(supplyCurrentToAdd) {
      //console.log(supplyCurrentToAdd, "abs supply", Math.abs(supplyCurrentToAdd), "total", this.get("totalSupplyCurrent")+Math.abs(supplyCurrentToAdd));
      this.set("totalSupplyCurrent", this.get("totalSupplyCurrent")+Math.abs(supplyCurrentToAdd));
    },

    addCurrentConsumption                      : function(currentConsumptionToAdd) {
      //console.log("consumption", Math.abs(currentConsumptionToAdd), "total", this.get("totalCurrentConsumption")+Math.abs(currentConsumptionToAdd));
      this.set("totalCurrentConsumption", this.get("totalCurrentConsumption")+Math.abs(currentConsumptionToAdd));
    },

    resetCurrents                              : function() {
      this.set("totalSupplyCurrent", 0);
      this.set("totalCurrentConsumption", 0);
      BticinoS4B.Instances.Models.ApplicationModel.set("maxExtraConsumption", []);
      //console.log("-------------RESET---------------");
    },

    recalculatePercentages                     : function() {
      var totalSupplyCurrent                  = this.get("totalSupplyCurrent");
      var totalCurrentConsumption             = this.get("totalCurrentConsumption");
      var maxExtraConsumptions                = BticinoS4B.Instances.Models.ApplicationModel.get("maxExtraConsumption");

      for (var i in maxExtraConsumptions)
        if (typeof maxExtraConsumptions[i] !== 'function')
          totalCurrentConsumption += maxExtraConsumptions[i];
      
      //console.log(totalCurrentConsumption);
      percentageOfTotalCurrentConsumption = totalCurrentConsumption*100/totalSupplyCurrent;
      //console.log('SUPPLY: ' + totalSupplyCurrent + ' CONSUMPTION: ' + totalCurrentConsumption + ' PERCENT: ' + percentageOfTotalCurrentConsumption);
      
      this.set("totalSupplyCurrent", totalSupplyCurrent);
      this.get("totalCurrentConsumption", totalCurrentConsumption);
      this.set("percentageOfTotalCurrentConsumption", percentageOfTotalCurrentConsumption);
    }

  });

  var consumptionIndicator = {
    View : consumptionIndicatorView,
    Model: consumptionIndicatorModel
  };

  return consumptionIndicator;

});